export default "__VITE_ASSET___9$aRZKM__"